import React, { useRef, useState } from "react"
import { useParams } from "react-router-dom"
import BaseLayout from "components/BaseLayout"
import { ApiTable } from "components/Common/Table"
import CustomButton from "components/Common/CustomButton"
import { TreeCommentDetail } from "../TreeCommentDetail/TreeCommentDetail"
import Modal from "components/Common/Modal"
import {
  getTreeComments,
  updateTreeCommentByCommentId,
} from "helpers/backend_helper"
import { isEmpty } from "lodash"
import { toast } from "helpers/cms_helper"
import { columns } from "./columns"

export function TreeSubmissionCommentsList() {
  const { id } = useParams()
  const tableRef = useRef(null)
  const [treeComment, setTreeComment] = useState({})

  function fetchTreeComments(params) {
    return getTreeComments({ ...params, treeListingId: id })
  }

  function handleCloseModal() {
    setTreeComment({})
  }

  function handleEdit(row) {
    setTreeComment({ id: row.id, hidden: !row.hidden, message: row.message })
  }

  async function handleSubmit(values) {
    const payload = {
      hidden: !values.hidden,
    }

    try {
      await updateTreeCommentByCommentId(treeComment.id, payload)
      toast(`Successfully updated comment #${treeComment.id}`)
      setTreeComment({})
      tableRef.current.refetch()
    } catch (error) {
      toast(error, true)
    }
  }

  return (
    <BaseLayout title="Tree Comments">
      <ApiTable
        fetchOnMount
        ref={tableRef}
        name="tree-comments-list"
        fetch={fetchTreeComments}
        columns={columns}
        rowButtons={(row) => (
          <CustomButton
            className="btn-outline-dark"
            onClick={() => handleEdit(row)}
          >
            Edit
          </CustomButton>
        )}
      />
      <Modal
        title={`Edit Tree Comment #${treeComment.id}`}
        isOpen={!isEmpty(treeComment)}
        onToggle={handleCloseModal}
      >
        <TreeCommentDetail data={treeComment} handleSubmit={handleSubmit} />
      </Modal>
    </BaseLayout>
  )
}
